import React from 'react';
import Propstype from 'prop-types';
import Panel from '../panel/panel';

const PanelBasico = (props) => {
  const { titulo, contenido = '' } = props;
  if (contenido === '') return null;
  return (
    <Panel titulo={titulo}>
      <div style={{ whiteSpace: 'pre-wrap' }} className='text-sm text-gray-600'>
        {contenido}
      </div>
    </Panel>
  );
};

PanelBasico.prototype = {
  titulo: Propstype.string,
  contenido: Propstype.string,
};

export default PanelBasico;
